module.exports = __webpack_public_path__ + "img/novato.52e703d4.png";